import React from 'react';
import * as api from '../../../services/api';
import CustomerSelectPage from '../../presenters/ManagedRestroomServices/CustomerSelectPage/CustomerSelectPage';
import LoadingWidget from '../../widgets/LoadingWidget/LoadingWidget';
import OverlayLoading from '../../widgets/LoadingWidget/OverlayLoadingWidget';
import { getBranchIds, getBranchRouteNumbers } from '../../../utils/api-util';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import { injectIntl } from 'react-intl';
import { MRS_SIZE_CODE } from '../../../constants/constants';
import { IN_PROGRESS, COMPLETED } from '../../../constants/MRSStatus';
import { MRS_ORDER_URL } from '../../../route-names';

const initialSearchOptions = {
  page: {
    size: '20',
    number: 0
  },
  sortBy: {
    name: null,
    direction: null
  }
};

class CustomerSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      paginatedCustomers: {},
      loading: false,
      orderSearchLoading: false,
      customerSearchOptions: initialSearchOptions,
      dialogMessage: null,
      action: null,
      plpc: {},
      searchString: null
    };
  }

  componentDidMount() {
    this.getCustomers();
  }

  onChangeCustomerPage = (page) => {
    this.setState(
      (prev) => ({
        customerSearchOptions: {
          ...prev.customerSearchOptions,
          page: { ...prev.page, number: page }
        }
      }),
      this.getCustomers
    );
  };

  onChangeCustomerRowsPerPage = (rowsPerPage) => {
    this.setState(
      (prev) => ({
        customerSearchOptions: {
          ...prev.customerSearchOptions,
          page: { ...prev.page, size: rowsPerPage }
        }
      }),
      this.getCustomers
    );
  };

  handleCustomerSearch = (searchValue) => {
    this.setState(
      {
        customerSearchOptions: initialSearchOptions,
        searchString: searchValue
      },
      this.getCustomers
    );
  };

  getCustomers = () => {
    this.setState({ loading: true });

    const { activeBranchId, branches, routes } = this.props.appStore;
    const branchIds = getBranchIds(activeBranchId, branches);
    const allowedRoutes = routes.filter((route) =>
      branchIds.includes(route.branchId)
    );

    const branchRouteNumbers = getBranchRouteNumbers(null, allowedRoutes);

    api.customers
      .search(this.state.customerSearchOptions, {
        search: this.state.searchString,
        branchIds,
        branchRouteNumbers
      })
      .then((response) => {
        const paginatedCustomers = response.data;

        // Each time we load customers, get their PLPC records so we can do frontend filtering
        Promise.all(
          paginatedCustomers.content.map((customer) => {
            return api.customerProducts
              .getLineItemsByCustomer({
                branchId: customer.branchId,
                routeNumber: customer.routeNumber,
                customerId: customer.customerId
              })
              .then((response) => {
                this.setState((prev) => ({
                  plpc: { ...prev.plpc, [customer.customerId]: response.data }
                }));
              });
          })
        )
          .then(() => {
            this.setState({ loading: false });
          })
          .catch(() => {
            this.setState({ loading: false });
          });

        this.setState({
          paginatedCustomers: paginatedCustomers
        });
      });
  };

  /**
   * MRS customer present on customer
   * contract usage = 0
   * Can't have MRSEA in customer products
   * must have weekly delivery already in customer products
   */
  shouldDisableCustomer = (customer) => {
    const hasMRS = this.state.plpc[customer.customerId]?.some(
      (plpc) => plpc.sizeCode == MRS_SIZE_CODE
    );

    if (
      typeof customer.mrsCustomer == 'object'
      && customer.mrsCustomer != null
      && !hasMRS
    ) {
      return false;
    }
    return true;
  };

  handleCustomerSelect = (customer) => {
    this.setState({ orderSearchLoading: true });
    api.mrsOrders.getByCustomer(customer).then((response) => {
      // Check for existing orders first
      if (response.data.totalElements == 0) {
        // Create order and navigate to orders page
        api.mrsOrders.create(customer).then((response) => {
          this.setState({ orderSearchLoading: false });
          this.props.history.push(
            MRS_ORDER_URL.replace(':orderId', response.data.mrsOrderId)
          );
        });
      } else {
        this.setState({ orderSearchLoading: false });

        // Response is paginated but it should only ever contain one entry
        const order = response.data.content[0];

        if (order.status == IN_PROGRESS.name) {
          this.setState({
            action: () => this.continueInProgressOrder(order),
            dialogMessage: this.props.intl.formatMessage({
              id: 'mrs_order_in_progress_warning'
            })
          });
        } else if (order.status == COMPLETED.name) {
          this.setState({
            action: null,
            dialogMessage: this.props.intl.formatMessage({
              id: 'mrs_order_already_completed_warning'
            })
          });
        }
      }
    });
  };

  handleClose = () => {
    this.setState({ action: null, dialogMessage: null });
  };

  continueInProgressOrder = (order) => {
    this.props.history.push(
      MRS_ORDER_URL.replace(':orderId', order.mrsOrderId)
    );
  };

  render() {
    // Initial load
    if (
      this.state.loading &&
      Object.keys(this.state.paginatedCustomers).length == 0
    ) {
      return <LoadingWidget />;
    } else {
      return (
        <>
          {(this.state.orderSearchLoading || this.state.loading) && (
            <OverlayLoading />
          )}
          <CustomerSelectPage
            handleCustomerSelect={this.handleCustomerSelect}
            onCustomerSearch={this.handleCustomerSearch}
            paginatedCustomers={this.state.paginatedCustomers}
            onChangePage={this.onChangeCustomerPage}
            onChangeRowsPerPage={this.onChangeCustomerRowsPerPage}
            shouldDisableCustomer={this.shouldDisableCustomer}
          />
          <Dialog className="dialog-wrapper" open={!!this.state.dialogMessage} onClose={this.handleClose}>
            <DialogTitle>{this.state.dialogMessage}</DialogTitle>
            <DialogActions className="dialog-action-buttons">
              <span className="btn-secondary-action">
                <Button onClick={this.handleClose} color="primary">
                  {this.props.intl.formatMessage({
                    id: 'cancel'
                  })}
                </Button>
              </span>
              {this.state.action && typeof this.state.action == 'function' && (
                <span className="btn-action">
                  <Button onClick={this.state.action} color="primary">
                    {this.props.intl.formatMessage({
                      id: 'mrs_continue'
                    })}
                  </Button>
                </span>
              )}
            </DialogActions>
          </Dialog>
        </>
    );
    }
    }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

export default connect(mapStateToProps)(withRouter(injectIntl(CustomerSearch)));
